<template>
  <div class="flow-form row">
    <template v-for="(c, key) in campos">
      <div
        v-show="!Object.keys(c).includes('ignorar') || !c.ignorar"
        :class="'column col-md-' + (c.size ? c.size : 12)"
        :key="'form_col_' + key"
      >
        <!-- inputs normais html -->
        <base-input
          v-if="
            [
              'text',
              'email',
              'number',
              'tel',
              'color',
              'date',
              'datetime-local',
              'month',
              'password',
              'range',
              'search',
              'time',
              'url',
              'week',
            ].includes(c.type)
          "
          :type="c.type"
          :key="key"
          :ref="'campo_' + key"
          :label="c.label"
          :placeholder="c.placeholder"
          :mask="c.mask"
          :required="c.req"
          :max="c.max"
          :maxlength="c.maxlength"
          :step="c.step"
          :error="c.error"
          :disabled="c.disabled || campoLeitura(c)"
          v-model="c.value"
          :inputClasses="c.class + ' form-control-alternative campo_' + key + (campoLeitura(c) ? ' leitura' : '')"
          class="mb-3"
          :class="{ 'input-group-alternative': !c.label }"
          :addonLeftIcon="c.ico"
          @change="change(c)"
          @input="input(c)"
          @focus="focus(c)"
          @blur="blur(c)"
          v-bind="$attrs"
        ></base-input>
        <!-- textarea formatado -->
        <text-editor
          v-if="c.type == 'textarea-formatado'"
          :key="key"
          :ref="'campo_' + key"
          :label="c.label"
          :placeholder="c.placeholder"
          :required="c.req"
          :error="c.error"
          :disabled="c.disabled || campoLeitura(c)"
          v-model="c.value"
          :inputClasses="c.class + ' form-control-alternative campo_' + key + (campoLeitura(c) ? ' leitura' : '')"
          :class="{ 'mb-3 input-group-alternative': !c.label}"
          :addonLeftIcon="c.ico"
          @change="change(c)"
          @input="input(c)"
          @focus="focus(c)"
          @blur="blur(c)"
          alternative
        />
        <!-- textarea normal -->
        <base-input
          v-if="c.type == 'textarea'"
          :type="c.type"
          :key="key"
          :ref="'campo_' + key"
          :label="c.label"
          :required="c.req"
          :error="c.error"
          :disabled="c.disabled || campoLeitura(c)"
          v-model="c.value"
          :inputClasses="c.class + ' form-control-alternative campo_' + key + (campoLeitura(c) ? ' leitura' : '')"
          :class="{ 'mb-3 input-group-alternative': !c.label }"
          :addonLeftIcon="c.ico"
          @change="change(c)"
          @input="input(c)"
          @focus="focus(c)"
          @blur="blur(c)"
        >
          <textarea
            rows="4"
            class="form-control form-control-alternative"
            :class="[c.class,{leitura: campoLeitura(c)}]"
            :placeholder="c.placeholder"
            v-model="c.value"
            :disabled="c.disabled || campoLeitura(c)"
          ></textarea>
        </base-input>
        <!-- campo select -->
        <base-input
          v-else-if="c.type == 'select'"
          :key="key"
          :ref="'campo_' + key"
          :label="c.label"
          :error="c.error"
          :class="{ 'mb-3 input-group-alternative': !c.label }"
        >
          <multiselect
            v-model="c.value"
            track-by="valor"
            label="nome"
            :options="c.opcoes"
            :placeholder="c.placeholder"
            selectLabel="Selecionar"
            selectedLabel="Atual"
            deselectLabel="Remover"
            :disabled="c.disabled || campoLeitura(c)"
            :class="[c.class, 'campo_' + key,{leitura: campoLeitura(c)}]"
            @input="isComponent(c)"
          >
            <span slot="noResult">Nada encontrado</span>
          </multiselect>
        </base-input>
        <!-- campo slider -->
        <base-input
          v-else-if="c.type == 'slider'"
          :key="key"
          :label="c.label"
          :error="c.error"
          :class="[
            { 'mb-3 input-group-alternative': !c.label },
            'campo_' + key,
          ]"
          :ref="'campo_' + key"
        >
          <base-slider
            v-model="c.value"
            :disabled="c.disabled || campoLeitura(c)"
            :class="[c.class,{leitura: campoLeitura(c)}]"
            :range="c.range ? c.range : { min: 0, max: 100 }"
          ></base-slider>
        </base-input>
        <!-- campo banner -->
        <banner-editor
          v-else-if="c.type == 'banner'"
          :key="key"
          :campoBanner="c"
          :class="[c.class, 'campo_' + key]"
          :ref="'campo_' + key"
        ></banner-editor>
        <!-- HR para divisão -->
        <hr
          class="my-4"
          :class="[c.class, 'campo_' + key]"
          v-else-if="c.type == 'hr'"
          :key="'hr_' + key"
          :ref="'campo_' + key"
        />
        <!-- Subtítulo -->
        <h6
          v-else-if="c.type == 'h6'"
          class="heading-small mt-3 mb-1 text-muted mb-4"
          :class="[c.class, 'campo_' + key]"
          :key="'t_' + key"
          :ref="'campo_' + key"
        >
          {{ c.label }}
        </h6>
        <!-- Checkbox / Radio -->
        <base-input
          v-else-if="c.type == 'checkbox' || c.type == 'radio'"
          :key="key"
          :label="c.label"
          :error="c.error"
          :class="[
            { 'mb-3 input-group-alternative': !c.label },
            c.class,
            'campo_' + key,
          ]"
          :ref="'campo_' + key"
        >
          <div class="row col-12">
            <div
              class="boxSelecionavel grow my-1"
              :class="['col-md-' + (c.size && c.size / 2 > 4 ? c.size / 2 : 4)]"
              v-for="o in c.opcoes"
              :key="o.id"
            >
              <label
                class="selecionavel align-items-center bg-white p-2 col-12" :class="{clickable: !campoLeitura(c),leitura: campoLeitura(c)}"
              >
                <input
                  :type="c.type"
                  v-model="c.value"
                  :value="o.id"
                  :disabled="c.disabled || o.disabled"
                  class="mr-2"
                  v-if="!campoLeitura(c)"
                />
                <span v-else :class="c.value.includes(o.id) ? 'fas fa-check-square' : 'far fa-square'"></span>
                {{ o.nome }}
              </label>
            </div>
          </div>
        </base-input>
        <!-- Slots personalizados -->
        <base-input
          v-else-if="c.type == 'personalizado'"
          :key="key"
          :label="c.label"
          :error="c.error"
          :class="[c.class, 'campo_' + key]"
        >
          <slot :name="key"></slot>
        </base-input>
      </div>
      <template v-if="c.type == 'card'"></template>
    </template>
    <slot></slot>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import devtools from "@/cflow/devtools";

export default {
  components: {
    Multiselect,
  },
  name: "flow-form",
  props: {
    campos: {
      type: Object,
      description:
        "Um objeto de objetos que irão compor este formulário (array aceita, fazendo vários campos na mesma linha). Ex: {campoA:{label:'aaa', val:'', req:false, placeholder:'', ico:'', msg:'', error:'', class='',ignore: false},rowExample:{campoB:{...},campoC:{...},campoD:{...}},campoE:{...}}",
    },
    leitura: {
      type: Boolean,
      default: false,
      description:
        "Ativa o modo de leitura, assim nenhum campo é editável, ficando apenas o texto dos campos e alguns outros elementos",
    },
    teste: {
      type: Boolean,
      description:
        "Ativa o modo de teste, que fará seu formulário se preencher automaticamente assim que carregado",
    },
  },
  methods: {
    change: function (el) {
      if ("onChange" in el) el.onChange(el, this.campos, this);
      console.log("el", el)
    },
    input: function (el) {
      if ("onInput" in el) el.onInput(el, this.campos, this);
    },
    focus: function (el) {
      if ("onFocus" in el) el.onFocus(el, this.campos, this);
    },
    blur: function (el) {
      if ("onBlur" in el) el.onBlur(el, this.campos, this);
    },
    getSel: function (array, campo, val) {
      if (!val) return { id: 0, nome: "Selecione" };
      return array.find((el) => el[campo] == val);
    },
    campoLeitura: function (campo) {
      if(Object.keys(campo).includes('leitura') && campo.leitura === false) return false
      return campo.leitura || this.campos.leitura
    },
    isComponent: function () {
      const procValue = this.campos?.procedimento?.value?.valor || 0;
      const procName= this.campos?.procedimento?.value?.nome || '';
      const procSlug = this.slugify(procName);

      if(procSlug.includes('sobre-implante') || procSlug.includes('protocolo')) {
        console.log("YES, is a COMPONENTE!", procValue);
        this.campos.componente.disabled = false;
      } else {
        this.campos.componente.disabled = true;
        this.campos.componente.value = {};
      }
    },
    slugify: function(text) {
      return text
        .toString()                             // Garante que é string
        .normalize('NFD')                        // Separa acentos
        .replace(/[\u0300-\u036f]/g, '')         // Remove acentos
        .toLowerCase()                           // Converte para minúsculas
        .trim()                                  // Remove espaços das pontas
        .replace(/[^a-z0-9 -]/g, '')             // Remove caracteres especiais
        .replace(/\s+/g, '-')                    // Troca espaços por -
        .replace(/-+/g, '-');                    // Remove múltiplos -
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {
    // Modificar campos datetime-local caso tenham vindo do banco "errados"
    Object.entries(this.campos).some(campo=>{
      if(campo[1].value && campo[1].type && campo[1].type == 'datetime-local'){
        campo[1].value = campo[1].value.replace(':00.000000Z','')
      }
    })
    if (this.teste) {
      //   var app = this
      console.log("Modo de teste ativo, preenchendo formulário...");
      Object.entries(this.campos).some((item) => {
        const i = item[1];
        if(i.value === null || typeof i.value === 'object'){
          switch (i.type) {
            case "text": {
              i.value = devtools.lipsum(3);
              break;
            }
            case "textarea": {
              i.value = devtools.lipsum(30);
              break;
            }
            case "textarea-formatado": {
              i.value = '<p>'+devtools.lipsum(30)+'</p><p>'+devtools.lipsum(20)+'</p><p>'+devtools.lipsum(40)+'</p>';
              break;
            }
            case "date": {
              let date = new Date();
              let formatacao = {
                year: "numeric",
                month: "numeric",
                day: "numeric",
              };
              date = new Date(
                date.setDate(date.getDate() + Math.round(Math.random() * 30))
              ).toLocaleDateString("pt-BR", formatacao);
              date = date.split("/").reverse().join("-");
              i.value = date;
              break;
            }
            case "time": {
              let date = new Date();
              date = new Date(
                date.setHours(date.getHours() + Math.round(Math.random() * 30))
              ).toLocaleTimeString("pt-BR");
              i.value = date;
              break;
            }
            case "number": {
              i.value = Math.round(Math.random()*80)
              break;
            }
            case "checkbox":{
              while(Math.random() > 0.3){
                let alvo = i.opcoes[Math.round((i.opcoes.length-1)*Math.random())]
                if(i.value.includes(alvo.id)) i.value.splice(i.value.indexOf(alvo.id),1)
                else i.value.push(alvo.id)
              }
              break;
            }
            case "radio": {
              let alvo = i.opcoes[Math.round((i.opcoes.length-1)*Math.random())]
              i.value = alvo.id
              break;
            }
          }
        }
      });
      console.log("formulário preenchido.");
    }
  },
  beforeDestroy() {},
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.boxSelecionavel {
  max-width: none !important ;
}
.selecionavel {
  border-radius: 3px;
  box-shadow: 2px 2px 1px rgba(0, 0, 0, 0.05);
  border: transparent 1px solid;
  transition: border-color 0.2s;
}
.selecionavel:not(.leitura):hover {
  border-color: rgba(0, 0, 0, 0.15);
}
/deep/.leitura{
  background: transparent;
  border:none;
  border-bottom: 1px solid rgba(0,0,0,0.15);
  box-shadow: none;
  border-radius: 0;
  resize: none;
  outline: none;
}
/deep/.leitura.selecionavel{
    pointer-events: none;
}
</style>